// extracted by mini-css-extract-plugin
export default {"disabledTrigger":"style--disabledTrigger--5fcdd5"};